export type SiteRoute = 'timer' | 'home' | 'signup' | 'signin' | 'app' | 'invite' | 'delete-account' | 'not-found';
const careTabs = ['today','medications','history','sharing'];
export function siteRoute(pathname: string, hash = '', search = ''): SiteRoute {
  const path=pathname.replace(/\/+$/, '') || '/';
  if(invitationToken(pathname,hash,search))return 'invite';
  if(path==='/' && careTabs.includes(hash.slice(1)))return 'app'; // Preserve previous care bookmarks.
  return ({'/timer':'timer','/':'home','/signup':'signup','/signin':'signin','/app':'app','/invite':'invite','/delete-account':'delete-account'} as Record<string,SiteRoute>)[path] ?? 'not-found';
}
export function invitationToken(pathname: string, hash: string, search=''): string | null {
  const path=pathname.replace(/\/+$/, '') || '/';
  if(['/invite','/signin','/signup'].includes(path) && /^#[a-f0-9]{64}$/.test(hash))return hash.slice(1);
  const legacy=new URLSearchParams(search).get('invite');
  return legacy && /^[a-f0-9]{64}$/.test(legacy) ? legacy : null;
}
export function pastedInvitationToken(value:string):string|null {
  if(/^[a-f0-9]{64}$/.test(value.trim()))return value.trim();
  try {const url=new URL(value.trim());if(url.protocol!=='https:'||url.hostname!=='bellatracker.com'||url.port||url.username||url.password)return null;return invitationToken(url.pathname,url.hash,url.search);} catch {return null;}
}
export function afterAuthentication(token: string|null): string {return token ? `/invite#${token}` : '/app';}
export function requireCareSignIn(route: SiteRoute, authReady: boolean, signedIn: boolean, token: string|null): string|null {
  return authReady && !signedIn && route === 'app' ? (token ? `/signin#${token}` : '/timer') : null;
}
